import { Text, View } from "@react-pdf/renderer";
import React from "react";
import { borderStyleGray } from "../reportingHelpers";

const rowStyle = {
  fontSize: 8,
  flexDirection: "row",
  border: borderStyleGray,
  borderRight: "unset",
  borderBottom: "unset",
};

const cellStyle = {
  flexBasis: "20%",
  textAlign: "center",
  borderRight: borderStyleGray,
};

const LogTable = ({ intl, entries }) => (
  <View style={{ borderBottom: borderStyleGray, flexBasis: "32%" }}>
    <View style={rowStyle}>
      <Text style={cellStyle}>
        {intl.formatMessage({
          id: "reports.matchReport.team",
          defaultMessage: "Team",
        })}
      </Text>
      <Text style={cellStyle}>
        {intl.formatMessage({
          id: "reports.minute",
          defaultMessage: "Minute",
        })}
      </Text>
      <Text style={cellStyle}>
        {intl.formatMessage({
          id: "reports.matchReport.number",
          defaultMessage: "Number",
        })}
      </Text>
      <Text style={cellStyle}>
        {intl.formatMessage({
          id: "reports.matchReport.action",
          defaultMessage: "Action",
        })}
      </Text>
      <Text style={cellStyle}>
        {intl.formatMessage({
          id: "reports.matchReport.score",
          defaultMessage: "Score",
        })}
      </Text>
    </View>
    {entries.map((entry, index) => (
      <View style={rowStyle} key={index}>
        <Text style={cellStyle}>{entry?.team ?? " "}</Text>
        <Text style={cellStyle}>{entry?.minute}</Text>
        <Text style={cellStyle}>{entry?.number}</Text>
        <Text style={cellStyle}>{entry?.action}</Text>
        <Text style={cellStyle}>{entry?.score}</Text>
      </View>
    ))}
  </View>
);

const calculateScoringSections = (scoring) => {
  const columns = 3;
  const rowsPerColumn = Math.max(1, Math.ceil(scoring.length / columns));
  const totalCapacity = rowsPerColumn * columns;
  const padding = Math.max(0, totalCapacity - scoring.length);
  const arr = [...scoring, ...Array.from(Array(padding))];

  // Slice the array into three dynamic sections.
  return [
    arr.slice(0, rowsPerColumn),
    arr.slice(rowsPerColumn, rowsPerColumn * 2),
    arr.slice(rowsPerColumn * 2, totalCapacity),
  ]
};

const ScoringLog = ({ intl, scoring }) => {
  const scoringSections = calculateScoringSections(scoring);
  return (
    <View style={{ marginTop: 6 }}>
      <View
        style={{
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        <LogTable intl={intl} entries={scoringSections[0]} />
        <LogTable intl={intl} entries={scoringSections[1]} />
        <LogTable intl={intl} entries={scoringSections[2]} />
      </View>
      <Text style={{ fontSize: 6, textAlign: "right", marginTop: 4 }}>
        {intl.formatMessage({
          id: "reports.matchReport.scoringLogLegend",
          defaultMessage:
            "FG - Field Goal, PC - Penalty Corner, PS - Penalty Stroke",
        })}
      </Text>
    </View>
  );
};

export default ScoringLog;
